export const SECTION_LOCALE_ZHCHS = {
    expandLabel: 'å±å¼',
    collapseLabel: 'æ¶èµ·'
};
